import { Breadcrumb, BreadcrumbData } from '../../components/Breadcrumbs';

export function HubForkRepoCrumb(props: Partial<BreadcrumbData>) {
  return <Breadcrumb {...props} name="Fork" />;
}
